import { render, staticRenderFns } from "./GoogleTrend.vue?vue&type=template&id=3cdd41e8&"
import script from "./GoogleTrend.vue?vue&type=script&lang=js&"
export * from "./GoogleTrend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports